/** @jsx jsx */
import { useRef, useState } from 'react';
import { css, jsx } from '@emotion/core';
import Player from 'react-player';
import useClickOutside from '../hooks/useClickOutside';

const wrapperCss = css`
  width: 100%;
  height: 100%;
  background-color: #000;
`;

const closeCss = css`
  margin: 1em;
  width: 30px;
  height: 30px;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 10000;
  cursor: pointer;
  &:after,
  &:before {
    background-color: #fff;
    border-radius: 1px;
    content: '';
    display: block;
    position: absolute;
    height: 2px;
    width: 100%;
    top: 50%;
  }

  &:before {
    transform: rotate(135deg);
  }
  &:after {
    transform: rotate(-135deg);
  }

  @media (hover: hover) {
    opacity: 0;
    transition: opacity 350ms ease;

    *:hover > & {
      opacity: 0.5;
    }
    &:hover {
      opacity: 1;
    }
  }
`;

const playerCss = (playerReady) => css`
  opacity: ${playerReady ? 1 : 0};
  transition: opacity 300ms ease;
`;

const VideoPlayer = ({ closeAction, videoUrl }) => {
  const wrapperRef = useRef(null);
  const [playerReady, setPlayerReady] = useState(false);
  const [playing, setPlaying] = useState(true);

  const closePlayer = () => {
    setPlayerReady(false);
    setPlaying(false);
    setTimeout(closeAction, 300);
  };

  useClickOutside(wrapperRef.current, closePlayer);

  return (
    <div ref={wrapperRef} css={wrapperCss}>
      <div css={closeCss} onClick={closePlayer} />
      <Player
        css={playerCss(playerReady)}
        onReady={() => setPlayerReady(true)}
        url={videoUrl}
        controls
        playing={playing}
        width="100%"
        height="100%"
      />
    </div>
  );
};

export default VideoPlayer;
